module.exports = __webpack_public_path__ + "static/04-ee1b3844b2e969bb787f1cb9ba467248.jpg";